var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraphChartSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#ffffff;stroke-miterlimit:10;stroke-width:1.91px;}")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.45,
    y: 14.86,
    width: 3.82,
    height: 7.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 17.73,
    y: 9.14,
    width: 3.82,
    height: 13.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.09,
    y: 1.5,
    width: 3.82,
    height: 21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 0.55,
    y1: 22.5,
    x2: 23.45,
    y2: 22.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphChartSvgrepoCom);
export default __webpack_public_path__ + "static/media/graph-chart-svgrepo-com.48f18f81ef562fdde69ef32093889d33.svg";
export { ForwardRef as ReactComponent };